import request from "@/utils/request";

export function send(params) {
  return request({
    url: '/mail',
    method: 'post',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/mail.js